<template>
  <div>
    <div class="d-flex align-center flex-wrap mb-4" style="gap: 8px">
      <v-icon small color="grey darken-1">mdi-calendar-month</v-icon>
      <span class="text-h6 font-weight-bold">{{ tituloDoMes }}</span>
      <v-spacer />
      <v-btn small icon :disabled="carregando" @click="mudarMes(-1)">
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-btn small icon :disabled="carregando" @click="mudarMes(1)">
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
      <v-btn small text color="primary" :disabled="carregando" @click="irParaHoje">Hoje</v-btn>
    </div>
    <div v-if="carregando" class="carregando d-flex flex-column align-center justify-center">
      <v-progress-circular indeterminate color="primary" size="36" class="mb-3" />
      <span class="text-body-2 grey--text text--darken-1">
        Carregando a frequência de {{ tituloDoMes }}...
      </span>
    </div>

    <template v-else>
      <table class="calendario">
        <thead>
          <tr>
            <th v-for="dia of DIAS_DA_SEMANA" :key="dia">{{ dia }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(semana, indice) of semanas" :key="indice">
            <td
              v-for="(dia, posicao) of semana"
              :key="posicao"
              :class="{ 'fora-do-mes': !dia }"
              :style="dia && ehHoje(dia) ? destaqueDeHoje : null"
            >
              <v-tooltip v-if="dia" bottom>
                <template v-slot:activator="{ on, attrs }">
                  <div v-bind="attrs" v-on="on" class="celula">
                    <div
                      class="text-caption"
                      :class="
                        ehHoje(dia) ? 'font-weight-bold primary--text' : 'grey--text text--darken-3'
                      "
                    >
                      {{ dia.dia }}
                    </div>
                    <v-avatar :color="cor(dia)" size="26">
                      <span class="sigla font-weight-bold" :class="corDoTexto(dia)">
                        {{ dia.sigla }}
                      </span>
                    </v-avatar>
                  </div>
                </template>
                <span>{{ descricao(dia) }}</span>
              </v-tooltip>
            </td>
          </tr>
        </tbody>
      </table>

      <div class="d-flex flex-wrap mt-4" style="gap: 12px">
        <div v-for="item of legenda" :key="item.situacao" class="d-flex align-center">
          <v-avatar :color="CORES[item.situacao]" size="12" class="mr-2" />
          <span class="text-caption">{{ item.rotulo }} ({{ item.sigla }})</span>
        </div>
      </div>

      <v-divider class="my-4" />

      <div class="d-flex flex-wrap" style="gap: 8px">
        <v-chip small outlined>{{ resumo.dias_letivos || 0 }} dias letivos no mês</v-chip>
        <v-chip small :color="CORES.presenca" dark>{{ resumo.presenca || 0 }} com presença</v-chip>
        <v-chip small :color="CORES.falta" dark>{{ resumo.falta || 0 }} com falta</v-chip>
        <v-chip v-if="resumo.falta_justificada" small :color="CORES.falta_justificada" dark>
          {{ resumo.falta_justificada }} com falta justificada
        </v-chip>
        <v-chip
          v-if="resumo.aguardando_confirmacao"
          small
          :color="CORES.aguardando_confirmacao"
          dark
        >
          {{ resumo.aguardando_confirmacao }} aguardando confirmação
        </v-chip>
      </div>
    </template>
  </div>
</template>

<script>
const DIAS_DA_SEMANA = ["DOM", "SEG", "TER", "QUA", "QUI", "SEX", "SÁB"];

const CORES = {
  presenca: "#4caf50",
  falta: "error",
  falta_justificada: "blue darken-2",
  aguardando_confirmacao: "grey darken-1",
  nao_letivo: "grey lighten-2",
};

export default {
  name: "EHistoricoFrequenciaTab",
  props: {
    casoId: { type: [Number, String], required: true },
  },
  data() {
    const hoje = new Date();
    return {
      DIAS_DA_SEMANA,
      CORES,
      hoje: [
        hoje.getFullYear(),
        `${hoje.getMonth() + 1}`.padStart(2, "0"),
        `${hoje.getDate()}`.padStart(2, "0"),
      ].join("-"),
      mes: hoje.getMonth() + 1,
      ano: hoje.getFullYear(),
      dias: [],
      resumo: {},
      legenda: [],
      carregando: true,
    };
  },
  computed: {
    destaqueDeHoje() {
      return { boxShadow: `inset 0 0 0 2px ${this.$vuetify.theme.currentTheme.primary}` };
    },
    tituloDoMes() {
      const mes = this.$constants.meses.find((item) => item.id === this.mes);
      return `${mes ? mes.descricao : this.mes} / ${this.ano}`;
    },
    semanas() {
      if (!this.dias.length) return [];

      const primeiroDiaDaSemana = new Date(this.ano, this.mes - 1, 1).getDay();
      const celulas = [...Array(primeiroDiaDaSemana).fill(null), ...this.dias];
      const semanas = [];

      for (let inicio = 0; inicio < celulas.length; inicio += 7) {
        const semana = celulas.slice(inicio, inicio + 7);
        semanas.push([...semana, ...Array(7 - semana.length).fill(null)]);
      }

      return semanas;
    },
  },
  mounted() {
    this.carregar();
  },
  methods: {
    async carregar() {
      this.carregando = true;

      this.dias = [];
      this.resumo = {};

      try {
        const resposta = await this.$services.buscaAtivaService.historicoFrequencia(this.casoId, {
          mes: this.mes,
          ano: this.ano,
        });
        this.dias = resposta.dias;
        this.resumo = resposta.resumo;
        this.legenda = resposta.legenda;
      } catch (error) {
        this.$handleError(error);
      }
      this.carregando = false;
    },
    mudarMes(passo) {
      const referencia = new Date(this.ano, this.mes - 1 + passo, 1);
      this.mes = referencia.getMonth() + 1;
      this.ano = referencia.getFullYear();
      this.carregar();
    },
    irParaHoje() {
      const hoje = new Date();
      this.mes = hoje.getMonth() + 1;
      this.ano = hoje.getFullYear();
      this.carregar();
    },
    ehHoje(dia) {
      return dia.data === this.hoje;
    },
    cor(dia) {
      if (dia.situacao === "falta" && !dia.ausencia_total) return "warning";
      return CORES[dia.situacao];
    },
    corDoTexto(dia) {
      return dia.situacao === "nao_letivo" ? "grey--text text--darken-1" : "white--text";
    },
    descricao(dia) {
      const partes = [dia.rotulo];

      if (dia.faltas_injustificadas) {
        partes.push(`${dia.faltas_injustificadas} de ${dia.aulas_confirmadas} aula(s)`);
      } else if (dia.aulas_confirmadas) {
        partes.push(`${dia.aulas_confirmadas} aula(s) confirmada(s)`);
      }
      if (dia.faltas_justificadas) {
        partes.push(`${dia.faltas_justificadas} falta(s) justificada(s)`);
      }
      if (dia.aulas_aguardando) {
        partes.push(`${dia.aulas_aguardando} aguardando confirmação`);
      }

      return partes.join(" · ");
    },
  },
};
</script>

<style scoped>
.carregando {
  min-height: 360px;
}

.calendario {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.calendario th,
.calendario td {
  border: 1px solid rgba(0, 0, 0, 0.12);
  text-align: center;
}

.calendario th {
  padding: 6px 0;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.6);
  background-color: #fafafa;
}

.calendario td {
  height: 58px;
}

.fora-do-mes {
  background-color: #fafafa;
}

.celula {
  line-height: 1.2;
}

.sigla {
  font-size: 10px;
}
</style>
